module.exports = __webpack_public_path__ + "static/media/shogun-sport.07602109.jpg";